import React, {useEffect, useRef} from 'react'
import { useRecoilState, useRecoilValue } from 'recoil'
import { useLocalModal } from 'src/components/views/mkt04/Modal/provider'
import { ModalInnerScroll, ModalInnerText } from 'src/components/views/mkt04/Modal/view'
import { MvmoTermsState, MvnoCheckValue} from 'src/recoil/common'
import Lottie from "lottie-react";
import ArrowLottie from "src/assets/images/mkt04/arrow.json";
import {
    KTMVNOPopupWrap,
    TermsCheckBox,
    TermsCheckBoxWrap
} from "src/styles/styledcomponent/views/mkt04/KTMVNOModal";
import {useFormContext} from "react-hook-form";
import {JoinFormType} from "src/types/type";

const MVNOModalContent = () => {
    const mvnoTermsData = useRecoilValue(MvmoTermsState)
    const [mvnoCheckValue, setMvnoCheckValue] = useRecoilState(MvnoCheckValue)


    const acceptKTTerms = (e: React.ChangeEvent<HTMLInputElement>) => {
        setMvnoCheckValue(e.target.checked)
    }

    return (
        <KTMVNOPopupWrap>
                    <ModalInnerScroll>
                        <ModalInnerText
                            dangerouslySetInnerHTML={{
                                __html: decodeURIComponent(escape(atob(mvnoTermsData.Terms)))
                            }}
                        />
                    </ModalInnerScroll>
                <TermsCheckBoxWrap>
                    <input
                        type="checkbox"
                        id="terms-check"
                        checked={mvnoCheckValue}
                        onChange={acceptKTTerms}
                    />
                    <TermsCheckBox htmlFor="terms-check" isChecked={mvnoCheckValue}>
                        <i className="icon" />
                        <p
                            dangerouslySetInnerHTML={{
                                __html: decodeURIComponent(escape(atob(mvnoTermsData.TermsTitle)))
                            }}
                        />
                    </TermsCheckBox>
                </TermsCheckBoxWrap>
        </KTMVNOPopupWrap>
    )
}

export const useMVNOModal = () => {
    const { openModal, closeModal, closeModalWithFocus } = useLocalModal()
    const [mvnoCheckValue, setMvnoCheckValue] = useRecoilState(MvnoCheckValue)
    const { setFocus } = useFormContext<JoinFormType>();

    const mvnoRef = useRef(mvnoCheckValue)
    useEffect(() => { mvnoRef.current = mvnoCheckValue }, [mvnoCheckValue])

    const scheduleFocusApproval = (delay = 300) => {
        setTimeout(() => {
            setFocus('ApprovalNumber', { shouldSelect: true });

            const prev = window.onfocus;
            window.onfocus = () => {
                setTimeout(() => setFocus('ApprovalNumber', { shouldSelect: true }), 150);
                window.onfocus = prev || null;
            };
        }, delay);
    };

    const openMVNOModal = (onCertSubmit?: (query: any) => void, certQuery?: any) => {
        openModal({
            placement: 'center',
            width: '100%',
            maxWidth: 300,
            contents: {
                title: 'KT MVNO(알뜰폰)\n추가 약관 동의가 필요합니다.',
                desc: '아래 약관 확인 후 동의해주세요.',
                children: <MVNOModalContent />
            },
            actions: {
                cancel: {
                    text: '취소',
                    func: modalClose
                },
                submit: {
                    text: '동의 및 인증번호 받기',
                    icon: <Lottie animationData={ArrowLottie} loop autoplay />,
                    iconSize: 26,
                    iconInline: true,    
                    func: () => checkTermTrue(onCertSubmit, certQuery)
                }
            }
        })
    }

    const modalClose = () => {
        closeModal()
        setMvnoCheckValue(false)
        requestAnimationFrame(() => {
            setTimeout(() => {
                setFocus('ApprovalNumber', { shouldSelect: true });
                const prev = window.onfocus;
                window.onfocus = () => {
                    setTimeout(() => setFocus('ApprovalNumber', { shouldSelect: true }), 120);
                    window.onfocus = prev || null;
                };
            }, 80);
        });
    }

    const checkTermTrue = async (onCertSubmit?: (query: any) => Promise<any> | any, certQuery?: any) => {
        const proceed = async () => {
            closeModal();
            if (onCertSubmit && certQuery) {
                try { await onCertSubmit(certQuery); } catch {}
            }
            scheduleFocusApproval();
        };

        if (!mvnoRef.current) {
            openModal({
                placement: 'center',
                width: '100%',
                maxWidth: 300,
                offset: 16,
                contents: {
                    title: '서비스 이용을 위해 약관 동의가 필요해요',
                    desc: '전체(선택 미동의) 동의 후 인증번호가 발송돼요.'
                },
                actions: {
                    cancel: { text: '취소', func: () => closeModal() },
                    submit: {
                        text: '확인',
                        icon: <Lottie animationData={ArrowLottie} loop autoplay />,
                        iconSize: 26,
                        func: async () => {
                            closeModalWithFocus();
                            setMvnoCheckValue(true);
                            if (onCertSubmit && certQuery) {
                                try { await onCertSubmit(certQuery); } catch {}
                            }
                        }
                    }
                }
            });
        } else {
            await proceed();
        }
    };

    return {
        openMVNOModal,
        closeModal: modalClose,
        mvnoCheckValue
    }
}